var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowGreenLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 12,
    viewBox: "0 0 26 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 5.991c0 .662-.637 1.198-1.423 1.198H4.91L8.185 9.93c.558.482.545 1.254-.028 1.724-.574.47-1.492.459-2.05-.024L.413 6.84a1.194 1.194 0 0 1-.299-.395.963.963 0 0 1 0-.91c.068-.146.17-.28.3-.395L6.106.352c.558-.47 1.463-.47 2.021 0 .558.47.558 1.23 0 1.7L4.911 4.794h19.666c.786 0 1.423.536 1.423 1.197z",
    fill: "#40C706",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGreenLeft);
export default __webpack_public_path__ + "static/media/arrow-green-left.394208fa093a8afef5470b6d6eadaf1b.svg";
export { ForwardRef as ReactComponent };